import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { statementStyle } from '../Components/Statement';
import { EditingLockedContentContext } from 'Containers/EditingLockedContentContext';

const showProcedureCode = (d: IDocumentWithTypeV2<'pelvis'>) => d.procedureCode && d.procedureCode.length > 0;
const showStatement = (d: IDocumentWithTypeV2<'pelvis'>) => d.statement && d.statement.length > 0;

const Pelvis = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const showProcedureCodeHeader = documents.some(d => showProcedureCode(d));
  const showStatementHeader = documents.some(d => showStatement(d));

  const { openEditing } = React.useContext(EditingLockedContentContext);

  return (
    <HistorySection
      headerText={<FormattedMessage id={'imaging.pelvis'} />}
      newButton={
        <DocumentCreationButton
          name="pelvis"
          text={'imaging.newPelvicRontgen'}
          onClick={startEdit({}, 'pelvis')}
          width={15}
          height={3}
          fontSize={12}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            {showProcedureCodeHeader && (
              <Item xs={2}>
                <FormattedMessage id="imaging.procedureCode" />
              </Item>
            )}
            {showStatementHeader && (
              <Item xs={3}>
                <FormattedMessage id="imaging.statementText" />
              </Item>
            )}
            <Item xs={4}>
              <FormattedMessage id={'imaging.hipSubluxationLuxation'} />
            </Item>
            <Item xs={3}>
              <FormattedMessage id="imaging.migrationPercentage" />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            {showProcedureCodeHeader && <Item xs={2}>{showProcedureCode(d) ? d.procedureCode : ''}</Item>}
            {showStatementHeader && (
              <Item xs={3} style={statementStyle}>
                {showStatement(d) ? d.statement : ''}
              </Item>
            )}
            <Item xs={4}>
              {d.hipSubluxationLuxation ? <FormattedMessage id={`general.${d.hipSubluxationLuxation}`} /> : '-'}
            </Item>
            <Item xs={3}>
              {d.hipSubluxationLuxation === 'yes' && (d.migrationPercentage || d.migrationPercentage === 0)
                ? `${d.migrationPercentage} %`
                : '-'}
            </Item>
          </>
        )}
        makeDate
        makeControls
        historyRowControls={d => (
          <HistoryRowControls
            document={d}
            startEdit={d._lockedFor && d._source !== null ? doc => () => openEditing(doc, 'imaging.pelvis') : startEdit}
          />
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'pelvis'>[];
  startEdit: StartEdit;
}

export default Pelvis;
